"use client";

import React from "react";

export default function TopupFilters({ filters, options, onChange }) {
  const {
    country = "",
    region = "",
    subType = "",
  } = filters || {};

  const {
    countries = [],
    regions = [],
    subTypes = [],
  } = options || {};

  return (
    <div className="bg-surface border border-gray-700 rounded-xl p-4 space-y-4 text-textPrimary">
      
      {/* Region Select */}   
      <div>
        <label
          htmlFor="region-select"
          className="block text-sm font-medium text-textSecondary mb-1"
        >
          🌍 Region
        </label>
        <select
          id="region-select"
          className="w-full p-2 border border-gray-700 bg-background text-textPrimary rounded-md text-sm shadow-sm"
          value={region}
          onChange={(e) => onChange("region", e.target.value)}
        >
          <option value="">All Regions</option>
          {regions.map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>
      </div>

      {/* Country Select */}
      <div>
        <label
          htmlFor="country-select"
          className="block text-sm font-medium text-textSecondary mb-1"
        >
          🗺️ Country
        </label>
        <select
          id="country-select"
          className="w-full p-2 border border-gray-700 bg-background text-textPrimary rounded-md text-sm shadow-sm"
          value={country}
          onChange={(e) => onChange("country", e.target.value)}
        >
          <option value="">All Countries</option>
          {countries.map((c) => (
            <option key={c.code} value={c.code}>
              {c.name}
            </option>
          ))}
        </select>
      </div>

      {/* SubType Select */}
      <div>
        <label
          htmlFor="subtype-select"
          className="block text-sm font-medium text-textSecondary mb-1"
        >
          📦 Product Type
        </label>
        <select
          id="subtype-select"
          className="w-full p-2 border border-gray-700 bg-background text-textPrimary rounded-md text-sm shadow-sm"
          value={subType}
          onChange={(e) => onChange("subType", e.target.value)}
        >
          <option value="">All Types</option>
          {subTypes.map((t) => (
            <option key={t} value={t}>
              {t.replace("Mobile ", "")}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
